import React from 'react'
import WorshipOptionCard from './WorshipOptionCard';
import '../../../styles/containers/Prayer/components/worship-options.scss';
function WorshipOptions({selectedGodObj, setSelectedWorshipOptionObj}) {
    const OptionsElement = [];
    const {worshipOptions} = selectedGodObj;
    for(let i = 0; i < worshipOptions.length; i+=2) {
        OptionsElement.push(
            <div key={i+1} className="row d-flex justify-content-between worship-options-row">
                <div className="col d-flex justify-content-center">
                   <WorshipOptionCard key={i+1} 
                   position={i+1} worshipOptionObj={worshipOptions[i]} 
                   setSelectedWorshipOptionObj={setSelectedWorshipOptionObj}/>
                </div>
                {i+1 < worshipOptions.length && 
                    <div className="col d-flex justify-content-center">
                        <WorshipOptionCard key={i+2} position={i+2} 
                        worshipOptionObj={worshipOptions[i+1]} 
                        setSelectedWorshipOptionObj={setSelectedWorshipOptionObj}/>
                    </div>
                }
            </div>
        )
    }
    return (
        <div className='worship-options-container'>
            {OptionsElement}
        </div>
    )
}

export default WorshipOptions
